/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum DeckungsBeitrag {
    Einfach = 'Einfach',
    Detailiert = 'Detailiert'
  }

    export const DeckungsBeitragTranslocoMap: Record<DeckungsBeitrag, string> = {
    [DeckungsBeitrag.Einfach]: 'deckungsBeitrag.einfach',
    [DeckungsBeitrag.Detailiert]: 'deckungsBeitrag.detailiert',
    };

    export const DeckungsBeitragOptions = [
  { value: DeckungsBeitrag.Einfach, labelKey: 'deckungsBeitrag.einfach' },
  { value: DeckungsBeitrag.Detailiert, labelKey: 'deckungsBeitrag.detailiert' },
    ];

